// Says so when an editor came back with recovered work.
//
// Restoring silently would be worse than losing it: you'd have no idea
// whether what's on screen is what the server has, and might save changes
// you'd already decided against.
import React from 'react';
import { RotateCcw } from 'lucide-react';
import { draftAgeLabel } from '../../hooks/useDraftAutosave';

interface Props {
  savedAt?: number;
  onDiscard: () => void;
  /** What discarding goes back to — "the saved order", "a blank form". */
  discardsTo: string;
}

const RestoredDraftBanner: React.FC<Props> = ({ savedAt, onDiscard, discardsTo }) => {
  if (!savedAt) return null;
  return (
    <div className="flex items-start gap-3 flex-wrap bg-amber-50 border border-amber-200 text-amber-900 rounded px-3 py-2 text-sm">
      <RotateCcw size={15} className="mt-0.5 shrink-0" />
      <span className="flex-1 min-w-0">
        Unsaved changes from {draftAgeLabel(savedAt)} were restored. They
        haven't been saved yet.
      </span>
      <button
        type="button"
        onClick={onDiscard}
        className="underline hover:no-underline shrink-0"
      >
        Discard and use {discardsTo}
      </button>
    </div>
  );
};

export default RestoredDraftBanner;
